var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 1.05908V2.39242M3.33325 1.05908V2.39242",
    stroke: "#FFB700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.88775C1 4.98288 1 3.53044 1.83475 2.62801C2.66949 1.72559 4.01299 1.72559 6.7 1.72559H7.96667C10.6537 1.72559 11.9972 1.72559 12.8319 2.62801C13.6667 3.53044 13.6667 4.98288 13.6667 7.88775V8.23009C13.6667 11.135 13.6667 12.5874 12.8319 13.4898C11.9972 14.3923 10.6537 14.3923 7.96667 14.3923H6.7C4.01299 14.3923 2.66949 14.3923 1.83475 13.4898C1 12.5874 1 11.135 1 8.23009V7.88775Z",
    stroke: "#FFB700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 5.05908H13.3333",
    stroke: "#FFB700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.4ec9ddc9476fc5889a1ebd3fb6a3f5c3.svg";
export { ForwardRef as ReactComponent };